import React from "react";
import { useTranslation } from "react-i18next";
import { MotionReveal } from "./landing/MotionReveal";

const DownloadButtons = () => {
  const [t] = useTranslation("global");

  return (
    <section id="download" className="siat-download">
      <div className="siat-wrap siat-download__inner">
        <MotionReveal>
          <p className="siat-eyebrow">App</p>
          <h2>{t("download.title")}</h2>
          <p className="siat-lead">{t("download.description")}</p>
        </MotionReveal>
        <MotionReveal className="siat-download__badges" delay={0.1}>
          <a
            href="https://play.google.com/store/apps/details?id=io.cordova.alarmu"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Google Play"
            />
          </a>
          <a
            href="https://apps.apple.com/us/app/bodegalert/id1428944146"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="App Store"
            />
          </a>
        </MotionReveal>
      </div>
    </section>
  );
};

export default DownloadButtons;
